/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup';

const formulationFieldSchema = Yup.number()
  .transform((value, originalValue) => {
    if (
      originalValue === '' ||
      originalValue === null ||
      originalValue === undefined
    )
      return 0;
    const normalized = String(originalValue)
      .trim()
      .replace(/%$/, '');
    if (!/^-?(?:\d+(?:\.\d+)?|\.\d+)$/.test(normalized)) return Number.NaN;
    return Number(normalized);
  })
  .default(0)
  .typeError('Formulation must be a number')
  .min(0, 'Formulation must be at least 0%')
  .max(100, 'Formulation cannot exceed 100%');

const formulationSchema = Yup.object().shape({
  N: formulationFieldSchema,
  P: formulationFieldSchema,
  K: formulationFieldSchema,
  Ca: formulationFieldSchema,
  Mg: formulationFieldSchema,
  S: formulationFieldSchema,
  Fe: formulationFieldSchema,
  Cu: formulationFieldSchema,
  Mn: formulationFieldSchema,
  Zn: formulationFieldSchema,
  B: formulationFieldSchema,
  Mo: formulationFieldSchema,
  Cl: formulationFieldSchema
});

export const EditCustomProductSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  makeUp: Yup.string().when('type', {
    is: 'FERTILIZER',
    then: () =>
      Yup.string()
        .required('Required')
        .default('SOLID'),
    otherwise: () =>
      Yup.string()
        .notRequired()
        .nullable()
  }),
  type: Yup.string().required('Required'),
  manufacturer: Yup.string().required('Required'),
  standardUnit: Yup.string().required('Required'),
  formulation: formulationSchema,
  averagePricePerUnit: Yup.number()
    .typeError('List Price must be a number')
    .min(0, 'List Price must be a positive number')
    .notRequired(),
  densityInLbsPerGallon: Yup.number()
    .when('makeUp', {
      is: 'LIQUID',
      then: () =>
        Yup.mixed()
          .transform((value, originalValue) => {
            if (
              originalValue === '' ||
              originalValue === null ||
              originalValue === undefined
            )
              return null;
            const parsed = Number(originalValue);
            return Number.isNaN(parsed) ? originalValue : parsed;
          })
          .required('Required')
          .test(
            'is-number',
            'Density must be a valid number',
            value => value === null || typeof value === 'number'
          )
          .test(
            'is-positive',
            'Density must be a positive number',
            value => value === null || value === '' || value >= 0
          ),
      otherwise: () =>
        Yup.mixed()
          .transform((value, originalValue) => {
            if (originalValue === '') return originalValue;
            return Number(value);
          })
          .nullable()
          .notRequired()
          .test('is-number', 'Density must be a valid number', value => {
            if (value === null || value === undefined || value === '')
              return true;
            return typeof value === 'number' && !Number.isNaN(value);
          })
          .test('is-positive', 'Density must be a positive number', value => {
            if (value === null || value === undefined || value === '')
              return true;
            return value >= 0;
          })
    })
    .when('type', {
      is: 'SERVICES',
      then: () =>
        Yup.mixed()
          .nullable()
          .notRequired()
    }),
  density: Yup.number().when('makeUp', {
    is: 'LIQUID',
    then: () =>
      Yup.number()
        .required('Required')
        .positive('Density must be a positive number'),
    otherwise: () =>
      Yup.number()
        .nullable()
        .notRequired()
  })
});

export const EditCustomProductSchemaForService = Yup.object().shape({
  type: Yup.string().required('Required'),
  name: Yup.string().required('Required'),
  manufacturer: Yup.string().required('Required'),
  standardUnit: Yup.string().required('Required'),
  averagePricePerUnit: Yup.number()
    .typeError('List Price must be a number')
    .min(0, 'List Price must be a positive number')
    .notRequired()
});
